import { render, staticRenderFns } from "./showLeadDetails.vue?vue&type=template&id=383ccbc6"
import script from "./showLeadDetails.vue?vue&type=script&lang=js"
export * from "./showLeadDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports